module.exports = __webpack_public_path__ + "static/patient-donna-profile-img-df8ddd656422106becf86049f36ba115.jpg";